import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";


import useEventsAdmin from "./hooks/useEventsAdmin";

import EventsHero from "./components/EventsHero";
import EventsStatsGrid from "./components/EventsStatsGrid";
import EventsFiltersPanel from "./components/EventsFiltersPanel";
import EventsList from "./components/EventsList";
import EventsFormDrawer from "./components/EventsFormDrawer";
import EventsPreviewDrawer from "./components/EventsPreviewDrawer";
import EventsDeleteDrawer from "./components/EventsDeleteDrawer";

import AdminMediaPickerDrawer from "../_shared/ui/AdminMediaPickerDrawer";
import { EVENTS_MEDIA_CATEGORY_DEFAULT } from "./data/eventsAdminData";

export default function EventsAdmin() {
  useScrollToTop();
  const events = useEventsAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <EventsHero
        stats={events.stats}
        loading={events.loading}
        onCreate={events.openCreate}
      />

      {events.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {events.notice}
        </div>
      ) : null}

      {events.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {events.error}
        </div>
      ) : null}

      <EventsStatsGrid stats={events.stats} loading={events.loading} />

      <EventsFiltersPanel
        q={events.q}
        categorie={events.categorie}
        stateFilter={events.stateFilter}
        dateFrom={events.dateFrom}
        dateTo={events.dateTo}
        limit={events.limit}
        onChangeQ={events.setQ}
        onChangeCategorie={events.changeCategorie}
        onChangeStateFilter={events.changeStateFilter}
        onChangeDateFrom={events.changeDateFrom}
        onChangeDateTo={events.changeDateTo}
        onChangeLimit={events.changeLimit}
        onSubmit={events.onSubmitSearch}
        onReset={events.resetFilters}
        onRefresh={events.fetchData}
        loading={events.loading}
      />

      <EventsList
        items={events.items}
        loading={events.loading}
        total={events.total}
        page={events.page}
        totalPages={events.totalPages}
        actionId={events.actionId}
        onPageChange={events.setPage}
        onPreview={events.openPreview}
        onEdit={events.openEdit}
        onToggle={events.onToggle}
        onAskDelete={events.openDelete}
      />

      <EventsFormDrawer
        open={events.formOpen}
        form={events.form}
        fieldErrors={events.fieldErrors}
        saving={events.saving}
        isEdit={!!events.currentId}
        onClose={events.closeForm}
        onChange={events.updateFormField}
        onSave={events.onSave}
        onOpenMediaPicker={events.openMediaPicker}
      />

      <EventsPreviewDrawer
        open={!!events.previewItem}
        item={events.previewItem}
        onClose={events.closePreview}
        onEditFromPreview={events.openEditFromPreview}
      />

      <EventsDeleteDrawer
        open={!!events.deleteItem}
        item={events.deleteItem}
        deleting={events.deleting}
        onClose={events.closeDelete}
        onConfirm={events.onDelete}
      />

      <AdminMediaPickerDrawer
        open={events.mediaPickerOpen}
        onClose={events.closeMediaPicker}
        onSelect={events.handleSelectMedia}
        title="Choisir une vignette"
        subtitle="Sélectionnez une image pour illustrer l’événement."
        defaultCategory={EVENTS_MEDIA_CATEGORY_DEFAULT}
      />
    </div>
  );
}